import { CultureInfo } from '../culture-info.model';
import { CultureInfoNl } from './nl';

/**
 * @ignore
 */
export const CultureInfoNlSX: CultureInfo = {
  name: 'nl-SX',
  displayName: 'Nederlands (Sint-Maarten)',
  iso3LanguageCode: 'nld',
  iso2LanguageCode: 'nl',
  ietfLanguageTag: 'nl-SX',
  parent: CultureInfoNl
};
